import * as yup from 'yup';

/**
 * Reusable email validation schema using Yup
 * Validates that email is:
 * - Required (not empty)
 * - Valid email format
 */
export const emailValidationSchema = yup.object({
  email: yup
    .string()
    .required('Email address is required')
    .email('Please enter a valid email address'),
});

/**
 * Schema for forms that only have an email field
 * (e.g., ForgotMail, EmailVerification)
 */
export type EmailFormValues = yup.InferType<typeof emailValidationSchema>;
